import apiUrlConfig from "../environmentSettings"
export const apps = [
	{
		id: "p3-csr",
		name: "p3",
		description: "Manage all your CSR programs, track on ground impact in real time",
		icon: "assets/img/mei.svg",
		product: "Uniqus Consultech Inc",
		licenses: ["CSR"],
		topNav: [
			{
				title: "My Tasks",
				url: "/tasks",
				icon: "Sucess",
				hiddenInMobile: true
			},
			{
				title: "Programs",
				url: "/programs",
				icon: "Programs"
			}
		],
		landingRoute: "/programs"
	},
	{
		id: "p3-sust",
		name: "Sustainability",
		description: "Manage all your Sustainability programs, track on ground impact in real time",
		icon: "assets/img/sustainability.svg",
		product: "Uniqus Consultech Inc",
		licenses: ["SUS"],
		defaultLayout: "new-sidebar",
		topNav: [],
		landingRoute: "/sustainability/index"
	},
	{
		id: "p3-csr-gap",
		name: "p3 GAP",
		description: "Manage all your CSR programs, track on ground impact in real time",
		icon: "assets/img/mei.svg",
		product: "Uniqus Consultech Inc",
		licenses: ["GAP"],
		landingRoute: "/myTasks"
	},
	{
		id: "p3-canvas",
		name: "Dashboards",
		description: "Data visualization with interactive charts",
		icon: "assets/img/dashboard_new.svg",
		defaultLayout: "no-sidebar",
		licenses: ["CANVAS"],
		product: "Uniqus Consultech Inc",
		landingRoute: `${apiUrlConfig.apiConfig.canvasURL}`
	},
	{
		id: "p3-esg",
		name: "ESG UniVerse",
		description: "Manage ESG and GHG programs, disclosures and reporting",
		icon: "assets/img/sustainability.svg",
		product: "Uniqus Consultech Inc",
		// Either licence unlocks the app - GHG is a module inside an ESG program
		// (/modularUI/:programId/ghg/...), not a separately reachable landing page.
		licenses: ["ESG", "GHG"],
		// Relative so it resolves against the org's customDomain when one is set.
		landingRoute: "/modularUI/select-program"
	}
];

export const home = {
	id: "p3-launcher",
	name: "Home",
	icon: "assets/img/homeIcon.svg",
	topNav: [],
	landingRoute: "/home"
};
